import * as React from 'react';
import { createContact, emptyCreateContact } from '../../../../model/contact';
import { Grid, withStyles, StyledComponentProps, Hidden } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import { styles } from './styles';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';

interface IProps extends StyledComponentProps {
    addNewUser: (contact: createContact) => void;
}

interface IInternalState {
    contactToAdd: createContact;
    passwordValid: boolean;
    error: { emailErrText: string, passwordErrText: string, nameErrText: string, familyNameErrtext: string, confirmPasswordErrText: string },
}

class CompContainer extends React.Component<Partial<IProps>, IInternalState>
{

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            contactToAdd: emptyCreateContact(),
            passwordValid: false,
            error: { emailErrText: '', passwordErrText: '', nameErrText: '', familyNameErrtext: '', confirmPasswordErrText: '' },
        }
    }
    updateNewContact = (contact: createContact, type: keyof createContact) => {
        switch (type) {
            case "email": {
                this.onEmailTextChanged(contact);
                break;
            }
            case "password": {
                this.onPasswordTextChanged(contact);
                break;
            }
            case "name": {
                this.onNameChanged(contact);
                break;
            }
            case "confirmPassword": {
                this.onConfirmPasswordTextChanged(contact);
                break;
            }
            case "surname": {
                this.onFamilyNameChanged(contact);
                break;
            }
            default:{
                this.setState({
                    contactToAdd: contact,
                }) 
            }
        }
    }

    onEmailTextChanged = (contact: createContact) => {
        let valid = this.validateEmail(contact.email);
        this.setState(prevState => {
            return {
                contactToAdd: contact,
                error: {
                    ...prevState.error,
                    emailErrText: valid ? '' : 'email non valida'
                }
            }
        });
    }
    private onPasswordTextChanged = (contact: createContact) => {
        const valid = this.validatePasword(contact.password);
        this.setState(() => {
            return {
                contactToAdd: contact,
                passwordValid: valid
            }
        });
    }
    private onPasswordBlur = () => {
        if (!this.state.passwordValid) {
            this.setState({
                error: {
                    ...this.state.error,
                    passwordErrText: 'Formato password non valido'
                }
            })
        } else {
            this.setState({
                error: {
                    ...this.state.error,
                    passwordErrText: ''
                }
            })
        }

    }
    private onConfirmPasswordTextChanged = (contact: createContact) => {
        this.setState(prevState => {
            return {
                contactToAdd: contact,
                error: {
                    ...prevState.error,
                    confirmPasswordErrText:
                        contact.confirmPassword && prevState.contactToAdd &&
                            contact.confirmPassword !== contact.password ? 'le passsword non coincidono' : ''
                }
            }
        });
    }

    onNameChanged = (contact: createContact) => {
        this.setState(prevState => {
            return {
                contactToAdd: contact,
                error: {
                    ...prevState.error,
                    nameErrText: !contact.name ? 'campo obbligatorio' : ''
                }
            }
        });
    }

    onFamilyNameChanged = (contact: createContact) => {
        this.setState(prevState => {
            return {
                contactToAdd: contact,
                error: {
                    ...prevState.error,
                    familyNameErrText: !contact.surname ? 'campo obbligatorio' : ''
                }
            }
        });
    }

    validatePasword = (text: string): boolean => {
        //var regex = new RegExp('(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}');
        //eslint-disable-next-line
        var regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*_])(?=.{8,})")
        return regex.test(text);
    }
    validateEmail = (email: string) => {
        //eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    cannotSignup = () => {
        return Boolean
            (
                !this.state.contactToAdd ||
                !this.state.contactToAdd.email ||
                !this.state.contactToAdd.password ||
                !this.state.contactToAdd.confirmPassword ||
                !this.state.contactToAdd.surname ||
                !this.state.contactToAdd.name ||
                (this.state.error && (this.state.error.passwordErrText || this.state.error.emailErrText || this.state.error.confirmPasswordErrText)) ||
                !this.state.passwordValid
            );
    }

    render() {
        return (<>
            <Grid container spacing={1}>
                <Grid item sm={8} className={this.props.classes.nameSurnameContainer}>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <TextField
                                label="Nome"
                                value={this.state.contactToAdd.name}
                                error={this.state.error.nameErrText ? true: false}
                                helperText={this.state.error.nameErrText ? this.state.error.nameErrText : ""}
                                onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, name: e }, "name") }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <TextField
                                label="Cognome"
                                value={this.state.contactToAdd.surname}
                                error={this.state.error.familyNameErrtext ? true: false}
                                helperText={this.state.error.familyNameErrtext ? this.state.error.familyNameErrtext : ""}
                                onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, surname: e }, "surname") }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Hidden only={'xs'}>
                    <Grid item sm={4}>

                    </Grid>
                </Hidden>
                <Grid item sm={12}>
                    <TextField
                        label="Telefono"
                        value={this.state.contactToAdd.tel}
                        onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, tel: e }, "tel") }}

                    />
                </Grid>
                <Grid item sm={12}>

                    <TextField
                        label="E-mail"
                        value={this.state.contactToAdd.email}
                        error={this.state.error.emailErrText ? true: false}
                        helperText={this.state.error.emailErrText ? this.state.error.emailErrText : ""}
                        onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, email: e }, "email") }}
                    />
                </Grid>
                <Grid item sm={12}>
                    <TextField
                        label="Password"
                        type={"password"}
                        value={this.state.contactToAdd.password}
                        error={this.state.error.passwordErrText ? true: false}
                        helperText={this.state.error.passwordErrText ? this.state.error.passwordErrText : ""}
                        onBlur={() => this.onPasswordBlur()}
                        onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, password: e }, "password") }}
                    />
                </Grid>
                <Grid item sm={12}>
                    <TextField
                        label="Conferma Password"
                        type={"password"}
                        value={this.state.contactToAdd.confirmPassword}
                        error={this.state.error.confirmPasswordErrText ? true: false}
                        helperText={this.state.error.confirmPasswordErrText ? this.state.error.confirmPasswordErrText : ""}
                        onChange={(e) => { this.updateNewContact({ ...this.state.contactToAdd, confirmPassword: e }, "confirmPassword") }}
                    />
                </Grid>
            </Grid>
            <SaveIconButton disabled={this.cannotSignup()} onClick={() => {
                this.props.addNewUser(this.state.contactToAdd)
            }} />
        </>
        )
    }
}




export const NewContact = (withStyles(styles)(CompContainer)) as React.ComponentType<IProps>;